import styles from './Spinner.module.css'

interface SpinnerProps {
  size?: number
  label?: string
}

export function Spinner({ size = 18, label = 'Carregando' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={styles.spinner}
      style={{ width: size, height: size }}
    />
  )
}
